import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import fetchStylistsBySalon from 'actions/stylist/fetchStylistsBySalon.action';
import SalonFlag from 'components/core/SalonFlag.component';
import Space from 'components/generic/Space.component';
import CurrencySign from 'components/price/CurrencySign.component';
import SF from 'constants/salonFlag.const';
import { selectCurrentSalonId, selectCurrentSalonStylists } from 'selectors/currentSalon.selectors';
import fromAnyToNumber from 'utils/converters/fromAnyToNumber.util';
import logger from 'utils/logger.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';

import CN from './DacCost.module.scss';

const L = logger('DacCost');

const DacCost = ({ stylists, salonId, fetchStylistsBySalon, salonFlags }) => {
  const columns = isFullArray(stylists)
    ? stylists.filter((s) => s.status !== 'deleted' && !s.serves_as_waitlist && s.has_column).length
    : 0;

  const oldPrice = columns * fromAnyToNumber(5);
  const newPrice = columns * fromAnyToNumber(6);

  useEffect(() => {
    L.unignore('useEffect()', 'fetchStylistsBySalon:', fetchStylistsBySalon(salonId));
  }, [fetchStylistsBySalon, salonId]);

  return (
    <div data-bem="DacCost" className={CN.component}>
      <Space>
        <SalonFlag name={SF.smsPricing}>
          <SalonFlag.IfDisabled>
            <CurrencySign value={newPrice} />
          </SalonFlag.IfDisabled>
          <SalonFlag.IfEnabled>
            <CurrencySign value={oldPrice} />
          </SalonFlag.IfEnabled>
        </SalonFlag>
      </Space>
    </div>
  );
};

const mapStateToProps = (state) => ({
  stylists: selectCurrentSalonStylists(state),
  salonId: selectCurrentSalonId(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ fetchStylistsBySalon }, dispatch);

const DacCostHoc = connect(mapStateToProps, mapDispatchToProps)(DacCost);

export default DacCostHoc;
